import BaseModel from "./base/baseModel";

export default class DadosAdicionaisFichaTecnicaModel extends BaseModel {
    id?: number = null;
    produtoId?: number = null;
    padrao?: boolean = false;
    descricao: string = null;
}